import React from "react";
import { Columns3 } from "lucide-react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuCheckboxItem, DropdownMenuLabel, DropdownMenuSeparator } from "./ui/dropdown-menu";

export const EXTRA_TASK_COLUMNS = [
  { k: "po_number", l: "PO #" },
  { k: "invoice_number", l: "Invoice #" },
  { k: "vendor", l: "Vendor" },
  { k: "vendor_contact", l: "Vendor Contact" },
  { k: "fulfillment_request_number", l: "Fulfillment Request #" },
  { k: "notes", l: "Notes" },
];

export default function TaskColumnsMenu({ hidden, onChange }) {
  const toggle = (k, show) => onChange(show ? hidden.filter((x) => x !== k) : [...hidden, k]);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="task-columns-menu-btn" className="inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm border border-slate-700 text-slate-300 hover:border-blue-500">
          <Columns3 size={14} /> Columns
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56" data-testid="task-columns-menu">
        <DropdownMenuLabel>Show columns</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {EXTRA_TASK_COLUMNS.map((c) => (
          <DropdownMenuCheckboxItem key={c.k} checked={!hidden.includes(c.k)} onCheckedChange={(v) => toggle(c.k, v)}
            onSelect={(e) => e.preventDefault()} data-testid={`task-column-toggle-${c.k}`}>
            {c.l}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
